module.exports = __webpack_public_path__ + "img/Products_Desktop-Recovered_04.b274d574.jpg";